import { ReportErrorParams } from '../../../api/feedback.types'
import { ReportErrorAction } from './report.error.types'
export const reportErrorRequestAction = (params: ReportErrorParams): ReportErrorAction => ({ type: 'REPORT_ERROR_REQUEST', params })
export const reportErrorSuccessAction = (): ReportErrorAction => ({ type: 'REPORT_ERROR_SUCCESS' })
export const reportErrorFailureAction = (error?: any): ReportErrorAction => ({ type: 'REPORT_ERROR_FAILURE', params: error })